import { Component, Input, OnInit } from '@angular/core';
import { TicketingReportDomainService } from "../../ticketing-report-domain.service";
import { CustomFieldType } from "@afidium/ts-facade";
import { ICodeName } from "libraries/service/resources/model/shared/ICodeName";


@Component({
    selector: 'custom-fields',
    template: `
        <div *ngFor="let customField of customFieldArrayTranslated"
             class="cols sep-top">
            {{customField.name}} : <strong>{{customField.value}}</strong>
        </div>`
})

export class CustomFieldsComponent implements OnInit {

    @Input()
    public customFieldArray: CustomFieldType[];

    public customFieldArrayTranslated: CustomFieldType[];

    constructor(
        private readonly ticketingReportDomainService: TicketingReportDomainService,
    ) {
    }

    public ngOnInit(): void {
        if (this.customFieldArray?.length) {
            this.ticketingReportDomainService.getCustomFields()
                .subscribe(
                    {
                        next: (enumResponse: ICodeName[]): void => {
                            if (enumResponse?.length) {
                                this.customFieldArrayTranslated =
                                    this.customFieldArray.map((customField: CustomFieldType): CustomFieldType => {
                                        const relatedTranslation: ICodeName = enumResponse
                                            .find((item: ICodeName): boolean => item.code === customField.name);
                                        return relatedTranslation ?
                                            {
                                                name: relatedTranslation.name,
                                                value: customField.value,
                                            } :
                                            customField;
                                    });
                            } else {
                                this.customFieldArrayTranslated = this.customFieldArray;
                            }

                        }
                    }
                );
        }

    }


}
